import BrowserStorage from '../BrowserStorage'

const LocalStorage = new BrowserStorage(localStorage)

export default LocalStorage
